// @flow

import React from 'react';
import { Cookies, withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import {
  getConvertedValueFromCurrentCurrency,
  undoConvertedValueFromCurrentCurrency,
} from '../../../../utils/currencyConvertorUtils';
import { splitThousand } from '../../../../utils/formatUtils';
import { defaultCurrency, twCurrency } from '../../../../const';
import type { SelectConvertorMap } from '../../../../types/commonTypes';

type Props = {
  label: string,
  value: string,
  unit: string,
  onChange: (event: EventTarget) => {},
  pattern: string,
  cookies: Cookies,
  currenciesList: SelectConvertorMap,
  showField?: boolean,
}

const RoiParamField = ({
  label, value, unit, onChange, pattern, cookies, currenciesList, showField,
}: Props) => {
  const show = (showField == null || showField);
  const isADayValue = (): boolean => unit === 'd';

  const formatValue = (newValue: number | string = ''): string => {
    const currentVal = newValue.toString()
      .replace(/[a-zA-Z\s]+/g, '');
    const intPortion = splitThousand(currentVal.split('.')[0])
      .replace('N/A', '');
    const decimalPresence = currentVal.includes('.') ? '.' : '';
    const decimals = currentVal.split('.').slice(1).join('');
    return `${intPortion}${decimalPresence}${decimals}`;
  };

  const handleChange = (e: EventHandler, minMax: string) => {
    let { value } = e.target;
    const cursorPosToEnd = value.length - e.target.selectionStart;
    value = reformatByUnit(value);
    const unformattedValue = unit === '€' ?
      undoConvertedValueFromCurrentCurrency(value.replace(/\s+/g, ''), currenciesList, cookies.get(twCurrency)) : value;
    onChange(unformattedValue, minMax);
    e.target.value = value;
    const newPosition = Math.max(value.length - cursorPosToEnd, 0);
    isASpaceBeforePointer(e.target.value, newPosition) ?
      e.target.setSelectionRange(newPosition - 1, newPosition - 1) :
      e.target.setSelectionRange(newPosition, newPosition);
  };

  const isASpaceBeforePointer = (newValue: string, cursorPos: number): boolean => (cursorPos === 0 ? false : newValue.substring(cursorPos - 1, cursorPos) === ' ');

  const getCurrentCurrencyUnit = (): string => {
    const currency = cookies.get(twCurrency) || defaultCurrency;
    const currentCurrency = currenciesList[currency];
    return currentCurrency.symbol;
  };

  const formatByUnit = (newValue: number | string): number | string => {
    if (isADayValue()) {
      return newValue;
    } else if (unit === '%') {
      return formatValue(newValue);
    }
    return formatValue(getConvertedValueFromCurrentCurrency(newValue, currenciesList, cookies.get(twCurrency)));
  };

  const reformatByUnit = (newValue: number | string): number | string => {
    if (isADayValue()) {
      return newValue;
    } else if (unit === '%') {
      return formatValue(newValue);
    }
    return formatValue(newValue.replace(/[\s.]+/g, ''));
  };

  const hasMixedUpValues = () => (value.min > value.max);

  const getUnit = () => {
    if (unit === '%') {
      return (
        <span className="roi-param-unit">{unit}</span>
      );
    }
    if (unit === '€') {
      return (
        <span className="roi-param-unit">{getCurrentCurrencyUnit()}</span>
      );
    }
    return (<span className="roi-param-unit">?</span>);
  };

  if (!show) {
    return (<></>);
  }
  return (
    <div className="roi-param-field">
      <div className="roi-input-container">
        <input
          type="text"
          className={`roi-input${hasMixedUpValues() ? ' roi-input--error' : ''}`}
          value={formatByUnit(value.min)}
          onChange={(e: EventHandler) => handleChange(e, 'min')}
          pattern={pattern}
        />
        {getUnit()}
      </div>
      <div className="roi-input-container">
        <input
          type="text"
          className={`roi-input${hasMixedUpValues() ? ' roi-input--error' : ''}`}
          value={formatByUnit(value.max)}
          onChange={(e: EventHandler) => handleChange(e, 'max')}
          pattern={pattern}
        />
        {getUnit()}
      </div>
    </div>
  );
};

export default withCookies(connect(state => ({
  currenciesList: state.dynamicKeys.currenciesList,
}))(RoiParamField));
